import {VatRate} from '@dms/api/shared';

export const vatRatesResponseMock: VatRate[] = [
  {
    code: 'CZE',
    rates: [
      {
        type: 'S',
        name: 'Standard VAT rate',
        rate: '21',
        activeFrom: '2013-01-01',
      },
      {
        type: 'R',
        name: 'Reduced VAT rate',
        rate: '12',
        activeFrom: '2024-01-01',
      },
      {
        type: 'E',
        name: 'Exempt from VAT',
        rate: '0',
        activeFrom: '1993-01-01',
      },
      {
        type: 'Z',
        name: 'Zero VAT rate',
        rate: '0',
        activeFrom: '1993-01-01',
      },
    ],
    calculationRule: {
      formulaFromWithoutVat: 'STANDARD_FROM_BELOW',
      formulaFromWithVat: 'STANDARD_FROM_ABOVE',
      roundType: 'ALGEBRAIC',
      roundScale: 2,
      roundStep: 1,
      activeFrom: '1993-01-01',
    },
  },
  {
    code: 'SVK',
    rates: [
      {
        type: 'S',
        name: 'Standard VAT rate',
        rate: '20',
        activeFrom: '2011-01-01',
      },
      {
        type: 'R',
        name: 'Reduced VAT rate',
        rate: '10',
        activeFrom: '2007-01-01',
      },
      {
        type: 'E',
        name: 'Exempt from VAT',
        rate: '0',
        activeFrom: '2007-01-01',
      },
      {
        type: 'Z',
        name: 'Zero VAT rate',
        rate: '0',
        activeFrom: '2007-01-01',
      },
    ],
    calculationRule: {
      formulaFromWithoutVat: 'STANDARD_FROM_BELOW',
      formulaFromWithVat: 'SLOVAKIAN_FROM_ABOVE',
      roundType: 'ALGEBRAIC',
      roundScale: 2,
      roundStep: 1,
      activeFrom: '2007-01-01',
    },
  },
  {
    code: 'POL',
    rates: [
      {
        type: 'S',
        name: 'Standard VAT rate',
        rate: '23',
        activeFrom: '2011-01-01',
      },
      {
        type: 'MR',
        name: 'Mid-reduced VAT rate',
        rate: '8',
        activeFrom: '2011-01-01',
      },
      {
        type: 'R',
        name: 'Reduced VAT rate',
        rate: '5',
        activeFrom: '2011-01-01',
      },
      {
        type: 'Z',
        name: 'Zero VAT rate',
        rate: '0',
        activeFrom: '2000-01-01',
      },
      {
        type: 'E',
        name: 'Exempt from VAT',
        rate: '0',
        activeFrom: '2000-01-01',
      },
    ],
    calculationRule: {
      formulaFromWithoutVat: 'STANDARD_FROM_BELOW',
      formulaFromWithVat: 'STANDARD_FROM_ABOVE',
      roundType: 'ALGEBRAIC',
      roundScale: 2,
      roundStep: 1,
      activeFrom: '2000-01-01',
    },
  },
  {
    code: 'BEL',
    rates: [
      {
        type: 'S',
        name: 'Standard VAT rate',
        rate: '21',
        activeFrom: '2020-01-01',
      },
      {
        type: 'MR',
        name: 'Mid-reduced VAT rate',
        rate: '6',
        activeFrom: '2020-01-01',
      },
      {
        type: 'R',
        name: 'Reduced VAT rate',
        rate: '12',
        activeFrom: '2011-01-01',
      },
      {
        type: 'Z',
        name: 'Zero VAT rate',
        rate: '0',
        activeFrom: '2000-01-01',
      },
      {
        type: 'E',
        name: 'Exempt from VAT',
        rate: '0',
        activeFrom: '2000-01-01',
      },
    ],
    calculationRule: {
      formulaFromWithoutVat: 'STANDARD_FROM_BELOW',
      formulaFromWithVat: 'STANDARD_FROM_ABOVE',
      roundType: 'ALGEBRAIC',
      roundScale: 2,
      roundStep: 1,
      activeFrom: '2000-01-01',
    },
  },
];
